module.exports = __webpack_public_path__ + "media/keyboard.ff6b678d.mp3";